// extracted by mini-css-extract-plugin
export var logo = "style-module--logo--2c283";
export var logoNav = "style-module--logo--nav--b83e9";
export var logoNavClosed = "style-module--logo--nav--closed--0fcb7";